<script>
export default {
    name: 'PartnerReportFilesPanel',
    props: {
        monthsPresent: {
            type: Array,
            default: () => [],
        },
        monthsMissing: {
            type: Array,
            default: () => [],
        },
        detailMonthsPresent: {
            type: Array,
            default: () => [],
        },
        fileDownloadBaseUrl: {
            type: String,
            default: '',
        },
    },
    methods: {
        fileUrl(month, fileKind) {
            if (!this.fileDownloadBaseUrl) {
                return '#';
            }

            return this.fileDownloadBaseUrl
                .replace('0000-00', month)
                .replace('__FILE__', fileKind);
        },
        hasDetail(month) {
            return this.detailMonthsPresent.includes(month);
        },
    },
};
</script>

<template>
    <div class="umg-means-card__section partner-report-files-panel">
        <div class="umg-means-card__section-head">
            <h4 class="umg-means-card__section-title">
                <i class="fa fa-file-excel-o umg-means-card__files-icon" aria-hidden="true" />
                {{ _t('Materialized CSV files') }}
            </h4>
        </div>
        <div
            class="umg-means-card__table-scroll partner-report-files-panel__table-scroll"
            role="region"
            :aria-label="_t('Materialized CSV files')"
            tabindex="0"
        >
            <p v-if="monthsMissing.length" class="umg-means-card__banner-text partner-report-files-panel__missing">
                {{ _t('Missing materialized months') }}: {{ monthsMissing.join(', ') }}
            </p>
            <table class="table umg-means-card__table partner-report-files-panel__table">
                <thead>
                    <tr>
                        <th>{{ _t('Month') }}</th>
                        <th>{{ _t('Aggregate') }}</th>
                        <th>{{ _t('Detail') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="month in monthsPresent" :key="month">
                        <td>{{ month }}</td>
                        <td>
                            <a
                                :href="fileUrl(month, 'aggregate')"
                                class="btn btn-link btn-xs"
                                target="_blank"
                                rel="noopener"
                            >
                                <i class="fa fa-download" aria-hidden="true" />
                                {{ _t('Download') }}
                            </a>
                        </td>
                        <td>
                            <a
                                v-if="hasDetail(month)"
                                :href="fileUrl(month, 'detail')"
                                class="btn btn-link btn-xs"
                                target="_blank"
                                rel="noopener"
                            >
                                <i class="fa fa-download" aria-hidden="true" />
                                {{ _t('Download') }}
                            </a>
                            <span v-else class="text-muted">{{ _t('Not materialized') }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped>
.partner-report-files-panel__missing {
    margin: 0 0 12px;
    color: var(--umg-means-warning-text, #7a5c1e);
}

.partner-report-files-panel__table-scroll {
    height: min(220px, 32vh);
}
</style>
